module.exports = __webpack_public_path__ + "static/img/desktop-clssdw.2faf0abf.png";